import { configMgmnt, parPage } from "../../config";
import { getQueryStringFrmObject, getApi, postApi, updateApi } from "../helpers/utility";
class ConfigMgmntApi {
  create = async (dividendPojo) => {
    if (dividendPojo) {
      var result = await postApi(configMgmnt.add, JSON.stringify(dividendPojo));
      return result;
    }
  };
  createDividend = async (dividendPojo) => {
    if (dividendPojo) {
      var result = await postApi(configMgmnt.addDividend, dividendPojo);
      return result;
    }
  };
  update = async(configPojo) =>{
    if (configPojo) {
      var result = await updateApi(configMgmnt.update, configPojo);
      return result;
  }
}
  readDividend= async (page) => {
    let finalListEndPoint;
    finalListEndPoint = configMgmnt.dividendlist + "?per_page=" + parPage+"&pageNo="+page;
    var result = await getApi(finalListEndPoint);
    return result;
  };
  readShare= async (readFilter, page) => {
    let finalListEndPoint;
    finalListEndPoint = configMgmnt.sharelist  ;
    let searchParams = { info: readFilter };
    if (searchParams.info) {
      finalListEndPoint = finalListEndPoint ;
    }
    var result = await getApi(finalListEndPoint);
    return result;
  };
  readInvestor= async (readFilter, page) => {
    let finalListEndPoint;
    finalListEndPoint = configMgmnt.investorlist  ;
    let searchParams = { info: readFilter };
    if (searchParams.info) {
      finalListEndPoint = finalListEndPoint ;
    }
    var result = await getApi(finalListEndPoint);
    return result;
  };
  readTax= async (readFilter, page) => {
    let finalListEndPoint;
    finalListEndPoint = configMgmnt.taxList  ;
    let searchParams = { info: readFilter };
    if (searchParams.info) {
      finalListEndPoint = finalListEndPoint ;
    }
    var result = await getApi(finalListEndPoint);
    return result;
  };
}
export default new ConfigMgmntApi();